import gtaLoggerInstance, { GTALogger } from './gtaLogger'
import gtaPerformanceInstance, { GTAPerformance } from './gtaPerformance'

declare global {
  interface Window {
    goToAdminLogger: Readonly<GTALogger>
    goToAdminPerformer: Readonly<GTAPerformance>
  }
}

window.goToAdminLogger = gtaLoggerInstance
window.goToAdminPerformer = gtaPerformanceInstance

export {}
